import React, { FC, HTMLAttributes, useEffect } from "react";
import MainLayout from "../components/main-layout";
import { DOCUMENT_TITLE_TYPE } from "../data/constants";
import { OutletStatusComponent } from "../features/outlet-status-page";
import { setDocumentTitle } from "../helpers/common-helper";
import { isMobileDevice } from "../helpers/device-info-helper";
import HeaderComponent from "../layouts/header";

const OutletStatusPage: FC<HTMLAttributes<HTMLDivElement>> = () => {
  useEffect(() => {
    return setDocumentTitle(DOCUMENT_TITLE_TYPE.outlets);
  }, []);

  return (
    <MainLayout activeTabIndex={4}>
      {isMobileDevice() ? null : (
        <HeaderComponent headingText={"Outlet Status"}></HeaderComponent>
      )}
      <OutletStatusComponent />
    </MainLayout>
  );
};

export default OutletStatusPage;
